import{Locale as e}from"../../../locale/Locale.enum.mjs";const a={asc:new Map([[e.ja,"昇順"],[e.en,"ASC"]]),desc:new Map([[e.ja,"降順"],[e.en,"DESC"]])};export{a as orderNameConfig};
